import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-calendar-tooltip',
    templateUrl: './calendar-tooltip.component.html',
    styleUrls: ['./calendar-tooltip.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CalendarTooltipComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
